import React from 'react'
import { withUserStore } from '../../contexts/UserStore'
import PageView from './PageView'
import PageProvider from '../../modules/PageProvider'
import Lex from '../Shared/Lex'

const Help = ({ userStore }) => {
  const page = {
    recordType: () => 'help',
    pageHeader: () => <h3 className="inline-block"><Lex term="help" /></h3>,
    formName: () => userStore.lex.help || 'Help',
    newRecord: () => ({}),
    records: () => [],
    filterRecords: () => true,
    formFields: () => (
      <div>
        <h4>Help Topics</h4>
        <p>This section will contain helpful information about using Prioritize.Plus.</p>
      </div>
    ),
    saveRecord: () => true,
    destroy: () => {},
    renderRecord: () => <div>Help content</div>
  }

  return <PageView pageProvider={PageProvider(page)} />
}

export default withUserStore(Help)
